module.exports = __webpack_public_path__ + "static/media/salary_demo.219af721.svg";